module.exports = __webpack_public_path__ + "static/media/1008454.a79c419a.png";